jQuery(function($) {
    let certPopup = {
        cert: {
            html: ''
        }
    };

    $(document).on('click', '.js-about-certificate', function(e) {
        e.preventDefault();
        let $this = $(this);
        let targetFile = $this.data('image');
        let imageHtml = $('<img/>', {
            src: targetFile,
            alt: targetFile
        });

        certPopup.cert.html = imageHtml[0].outerHTML;

        $.prompt(certPopup, {
            initialState: 'cert',
            classes: { prompt: 'jqi--width-by-content' },
            top: 10
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/about-certificates/about-certificates.js